import React, { ReactElement } from 'react'
import Button from '../button'
import Icon from '../icon'
import Text from '../text'
import {
  StyledDeleteModal,
  StyledButtons,
  StyledCard,
  StyledText,
} from './styled-components'

interface Props {
  title: string
  onCancel: () => void
  onDelete: () => void
  loadingDelete: boolean
}

const DeleteModal = ({
  title,
  onCancel,
  onDelete,
  loadingDelete,
}: Props): ReactElement => (
  <StyledDeleteModal>
    <StyledCard>
      <Icon
        name="fluent:delete-20-regular"
        width={80}
        height={80}
        color="red"
      />
      <StyledText>
        <Text underline>{title}</Text> <Text>هل تود حذف</Text>
      </StyledText>

      <StyledButtons>
        <Button onClick={onCancel} size="100px" color="white">
          <Text>الرجوع</Text>
        </Button>
        <Button
          loading={loadingDelete}
          onClick={onDelete}
          size="100px"
          color="red"
        >
          <Text>حذف</Text>
        </Button>
      </StyledButtons>
    </StyledCard>
  </StyledDeleteModal>
)

export default DeleteModal
